import withFlow from '../FlowManager/withFlow';
import ConsentsDefault from './Consents/Default';
import ConsentsPromotion from './Consents/Promotion';
import SelfAuth from './SelfAuth';
import RestrictedGames from './RestrictedGames';
import ParentConsents from './Parent/ParentConsentsAndSelfAuth';
import ParentEmail from './Parent/ParentEmail';
import ParentEmailComplete from './Parent/ParentEmailComplete';
import CheckAccount from './CheckAccount';
import ExistingAccounts from './CheckAccount/ExistingAccounts';
import PromotionCheckAccount from './CheckAccount/PromotionCheckAccount';
import Email from './Email';
import IdPasswd from './IdPasswd';
import AccountCreation from './AccountCreation';
import Success from './AccountCreation/Success';

import Promotion from './Promotion';

import SampleGrid from './SampleGrid';

const components = {
  ConsentsDefault,
  ConsentsPromotion,
  SelfAuth,
  RestrictedGames,
  ParentConsents,
  ParentEmail,
  ParentEmailComplete,
  CheckAccount,
  ExistingAccounts,
  PromotionCheckAccount,
  Email,
  IdPasswd,
  AccountCreation,
  Success,

  Promotion,

  SampleGrid
};

const wrappedComponents = Object.keys(components).reduce(
  (obj, item) => ((obj[item] = withFlow(components[item])), obj),
  {}
);

export default wrappedComponents;
